const appPath = typeof APP_PATH !== 'undefined' ? APP_PATH : 'mobile';

export const APP_ROUTES = {
  HOME: `/${appPath}`,
  OPTIONS: `/${appPath}/options`,
  EXAMPLE: `/${appPath}/example`,
  PRICE_LADDER: `/${appPath}/priceladder`
};

export const OPTIONS_ROUTES = {
  DEFAULT: '',
  TAGS: 'tags',
  CHART: 'chart',
  MODAL: 'modal',
  INPUTS: 'inputs',
  HEADER: 'header',
  BUTTONS: 'buttons',
  SERVICES: 'services',
  TOOLTIPS: 'tooltips',
  NAVIGATION: 'navigation',
  DATE_PICKER: 'date-picker',
  TRANSLATIONS: 'translations',
  SELECT_PICKER: 'select-picker'
};

export const NAVIGATION_ROUTE = {
  TRADE: 'trade',
  MARKETS: 'markets',
  ASSETS: 'assets',
  DEALER: 'dealer',
  SIGNAL: 'signal',
  CALENDAR: 'calendar',
  NEWS: 'news',
  MODAL: 'modal'
};

export const AUTHENTICATION_ROUTES = {
  LOGIN: `/${appPath}/login`,
  SIGN_UP_CRM: `/${appPath}/sign-up-crm`,
  SIGN_UP_DEMO: `/${appPath}/sign-up-demo`,
  FORGOT_PASSWORD_CRM: `/${appPath}/forgot-password-crm`,
  FORGOT_PASSWORD_LIVE: `/${appPath}/forgot-password-live`,
  RESET_PASSWORD: `/${appPath}/reset-password`
};

export const SECURED_ROUTES = {
  TRADE: `/${appPath}/trade`,
  MARKETS: `/${appPath}/markets`,
  ASSETS: `/${appPath}/assets`,
  SIGNAL: `/${appPath}/signal`,
  DEALER: `/${appPath}/dealer`,
  NEWS: `/${appPath}/news`,
  CALENDAR: `/${appPath}/calendar`,
  EDUCATION: `/${appPath}/education`,
  QUOTE: `/${appPath}/quote`,
  COPY_TRADE: `/${appPath}/copy-trade`,
  PELICAN_SSO_AUTHENTICATED: `/${appPath}/sso/pelican/authenticated`,
  LOGOUT: 'logout'
};
